import React, { useState, useEffect } from "react";
import { Row, Col, Alert } from "react-bootstrap";
import { object, bool } from "prop-types";
import { Base64 } from "js-base64";
import { ThreeBounce } from "better-react-spinkit";
import Chart from "chart.js";
import { getChartConfig } from "utils/helperFunctions";

const WorkStylesReport = ({
  workStylesData,
  workStylesLoaded,
  workStylesError,
}) => {
  const [workStylesHtml, setWorkStylesHtml] = useState("");
  const [workStylesScaledThetaScores, setWorkStylesScaledThetaScores] =
    useState([]);

  useEffect(() => {
    if (workStylesLoaded) {
      const decodedHtml = Base64.decode(workStylesData.get("report")).replace(
        /[Â]/g,
        ""
      );

      const adjustedScaledThetaScores = workStylesData
        .get("scaledThetaScores")
        .toArray()
        .map((score) => score + 10);

      setWorkStylesHtml(decodedHtml);
      setWorkStylesScaledThetaScores(adjustedScaledThetaScores);
    }
  }, [workStylesLoaded]);

  useEffect(() => {
    if (workStylesHtml && workStylesScaledThetaScores.length > 0) {
      Chart.defaults.global.defaultFontColor = "#001f4e";
      setTimeout(() => {
        const ctx = document.getElementById("workStylesChart")
          ? document.getElementById("workStylesChart").getContext("2d")
          : null;
        if (ctx) {
          // eslint-disable-next-line no-unused-vars
          const myRadarChart = new Chart(
            ctx,
            getChartConfig(workStylesScaledThetaScores, true, false)
          );
        }
      }, 100);
    }
  }, [workStylesHtml, workStylesScaledThetaScores]);

  const WorkStylesErrorAlert = (
    <Alert className="dynamic-score-report-error" variant="danger">
      There was an error retrieving this Work Styles report.
    </Alert>
  );

  return (
    <div>
      {workStylesError ? (
        WorkStylesErrorAlert
      ) : (
        <Row className="justify-content-center">
          {workStylesLoaded &&
          workStylesHtml &&
          workStylesScaledThetaScores.length > 0 ? (
            <Col
              className="mt-4"
              dangerouslySetInnerHTML={{ __html: workStylesHtml }}
            />
          ) : (
            <ThreeBounce color="#1F469A" size={30} className="mt-3" />
          )}
        </Row>
      )}
    </div>
  );
};

WorkStylesReport.propTypes = {
  workStylesData: object.isRequired,
  workStylesLoaded: bool.isRequired,
  workStylesError: bool.isRequired,
};

export default WorkStylesReport;
